"use cient";
import { Comment } from "@prisma/client";
import timeAgo from "@/components/ui/utils/timeAgo";
import Reactions from "./Reactions";
import Resolve from "./Resolve";

type props = {
  data: Comment;
  userId: string;
  handleResolve: ({
    commentId,
    isResolved,
  }: {
    commentId: string;
    isResolved: boolean;
  }) => void;
};

const ShowComment = ({ data, userId, handleResolve }: props) => {
  return (
    <div className="py-4 text-xs">
      <div>
        <span className="font-semibold">{data.createdBy}</span>
        <span className="ml-4 text-gray-400">
          hace {timeAgo(data.createdAt)}
        </span>
      </div>
      <p className="mt-2 whitespace-pre-wrap text-base font-light">
        {data.body}
      </p>

      <Reactions commentId={data.id} userId={userId} />
      <Resolve data={data} handleResolve={handleResolve} />
    </div>
  );
};

export default ShowComment;
